import { render, staticRenderFns } from "./BuddhismOrder.vue?vue&type=template&id=78f16784&scoped=true"
import script from "./BuddhismOrder.vue?vue&type=script&lang=js"
export * from "./BuddhismOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f16784",
  null
  
)

export default component.exports